<section id="solutions" class="solutions-v2">
  <header class="solutions-v2-header-container">
    <svg
      width="61"
      height="61"
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30.311" cy="30.5671" r="30.311" fill="#FAF2F2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M33.4489 24.7618L39.2529 30.5671L33.4489 36.3724L32.5049 35.4284L36.7009 31.2338H21.6436V29.9004H36.7009L32.5049 25.7058L33.4489 24.7618Z"
        fill="#00030A"
      />
    </svg>
    <h4>our recent solutions</h4>
  </header>

  <div class="solutions-v2-container">
    <app-solution
      style="width: 100%"
      *ngFor="let solution of solutions; let i = index"
      [image]="solution.image"
      [title]="solution.title"
      [description]="solution.description"
      [link]="solution.link"
      [alternate]="i % 2 === 0"
    ></app-solution>
  </div>
</section>
